import React from 'react'
import _ from "lodash"
import { TableMultiselect_s } from 'styles/input-styles'

export type MultiselectInterface = {
  attrs?: Function
  disabled?: boolean
  rowData: {}
  field: string|string[]
  options: Array<{label: string, value: string}> | string[]
  persist: Function
  default?: string
}

const MultiselectEdit = (props: MultiselectInterface) => {
  const attrs = (props.attrs && props.attrs(props.field)) || {}
  const value = !_.isNil(_.get(props.rowData, props.field)) ? _.get(props.rowData, props.field) : props.default ? props.default : null
  
  return (
    <TableMultiselect_s
      className="multiselect-input"
      disabled={props.disabled || false}
      value={value}
      options={props.options}
      onChange={e => props.persist(e.value, props.field, props.rowData)}
      {...attrs}
    />
  )
}

export default MultiselectEdit